// 選択Modal共通の「やめる/クリア ＋ けってい」フッター。
// .upsilon デザインシステムボタンで確実に色を付ける（やめる/クリア=青 btn-blue、けってい=緑固定）。
import I18n from "common/i18n";
import { btnDelay, usePlaySound } from "common/utils";

export const MenuActionFooter = ({
  onApply,
  secondaryLabel,
  onSecondary,
}: {
  // 互換のため受け取るが未使用（けっていは常に有効・緑固定）
  canApply?: boolean;
  onApply: () => void;
  // 左ボタンの文言キー（やめる / クリア）
  secondaryLabel: string;
  onSecondary: () => void;
  // 互換のため受け取るが未使用（けっていは緑固定）
  accentBgClass?: string;
}) => {
  const play = usePlaySound();

  const handleApply = () => {
    play();
    btnDelay(onApply);
  };

  const handleSecondary = () => {
    play();
    btnDelay(onSecondary);
  };

  return (
    <div className="flex-row-el flex-center justify-end w-full gap-2 upsilon">
      <button type="button" onClick={handleSecondary} className="type-inherit-font btn btn-blue">
        <div className="flex-row-center gap-1">
          <span className="material-symbols-outlined text-white type-md">close</span>
          <p className="type-text type-body text-white whitespace-nowrap">
            {I18n.t(secondaryLabel)}
          </p>
        </div>
      </button>
      <button type="button" onClick={handleApply} className="type-inherit-font btn !bg-green-100">
        <div className="flex-row-center gap-1">
          <span className="material-symbols-outlined text-white type-md">check</span>
          <p className="type-text type-body text-white whitespace-nowrap">
            {I18n.t("MSG_CONFIRM_BTN")}
          </p>
        </div>
      </button>
    </div>
  );
};
